import ReactDOM from "react-dom/client";
import Accordion from "../../components/Accordion/Accordion";

/*
 * Accordion
 * Use the existing DOM format since refactoring the whole sq_blocks_collapsible_item_block() method will
 * take more time than available and might not be worth the work.
 */
[...document.querySelectorAll(".cb.cb-collapsible_items")].forEach((element: HTMLElement) => {
  const accordions = [...element.querySelectorAll(".accordion")];

  // Target only collapsible items that contains accordions
  if (accordions.length === 0) {
    return;
  }

  const elements = accordions.map((accordionElement: HTMLElement, index) => {
    const content = accordionElement.querySelector(".accordion-content");

    if (!content) {
      return null;
    }

    // Find the first text child node, it should be the title of the accordion.
    const children = [...accordionElement.childNodes];
    const title = children.find(node => node.nodeType === 3)?.textContent.trim();

    return (
      <Accordion key={index} title={title}>
        {content}
      </Accordion>
    );
  });

  ReactDOM.createRoot(element).render(<div className="wrap cb-container">{elements}</div>);
});
